import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ObjectDetails from ".";

const ObjectDetailsOffcanvas = ({ show, onHide, vobject = null }) => {
    const { t } = useTranslation(["Objects"]);

    return (
        <Offcanvas
            placement="end"
            show={show}
            onHide={onHide}
            className="object-details-offcanvas"
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>{t("objectPopup.specification")}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <ObjectDetails readOnly={true} objectDetails={vobject?.objectDelails} />
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default ObjectDetailsOffcanvas;
